// extracted by mini-css-extract-plugin
module.exports = {"resultsDropdown":"SearchDropdownWrapper_resultsDropdown__ujXQx","wrapper":"SearchDropdownWrapper_wrapper__IwFrR","hero":"SearchDropdownWrapper_hero__Grcu7"};